import { visT } from "views/components/visualizations/visualizationTranslation";
export const areAtLeastNMetricsConfigured = (formValues, minimumMetrics) => {
  var _a;
  return ((_a = formValues.metrics) == null ? void 0 : _a.length) >= minimumMetrics;
};
export const areAtLeastNGroupingsConfigured = (formValues, minimumGroupings) => {
  var _a, _b;
  return ((_b = (_a = formValues.groupBy) == null ? void 0 : _a.groupings) == null ? void 0 : _b.length) >= minimumGroupings;
};
export const hasAtLeastOneMetric = (messageKey) => (formValues) => !areAtLeastNMetricsConfigured(formValues, 1) ? { type: visT(messageKey) } : {};
